import { luscinia } from "./luscinia";

luscinia.apiRequestWithNotification = async function(url: string, options?: object): Promise<boolean> {

    const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json' },
        ...options,
    });

    const result = await response.json();

    if (response.ok && result.success) {
        luscinia.showNotification("success", result.message || "Request successful!", "success");
        return true;
    } else {
        luscinia.showNotification("error", result.message || "An error occurred.", "danger");
        return false;
    }
}
